import { Candidate, Incident } from '../types/domain';
import { publicEnv } from '../config/env';
import { buildApiUrl } from './apiUrl';

const API_BASE = publicEnv.apiBaseUrl;

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const token = localStorage.getItem('mockExamToken');
  const response = await fetch(buildApiUrl(API_BASE, path), {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers
    }
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return (await response.json()) as T;
}

export const api = {
  async login(payload: { name: string; email: string; examCode: string }) {
    return request<{ token: string; candidate: Candidate }>('/auth/login', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },
  async saveIncident(incident: Incident) {
    return request<{ ok: true }>('/incidents', {
      method: 'POST',
      body: JSON.stringify(incident)
    });
  },
  async listIncidents() {
    return request<Incident[]>('/incidents');
  },
  async submitExam(payload: unknown) {
    return request<{ ok: true; reportId: string }>('/exam/submit', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};
